import { render, staticRenderFns } from "./meetingRoomCard.vue?vue&type=template&id=337e9225&"
import script from "./meetingRoomCard.vue?vue&type=script&lang=js&"
export * from "./meetingRoomCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports